var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Radio } from "@mui/material";
import { PeekFormControlLabel, PeekFormLabel, PeekMultipleSelector, PeekRadioGroup, PeekStack, useTheme, } from "@piiqtechnologies/ui-components";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
const CustomFormLabel = (_a) => {
    var { isChecked, label, onClick, disabled } = _a, props = __rest(_a, ["isChecked", "label", "onClick", "disabled"]);
    const theme = useTheme();
    return (React.createElement(PeekFormControlLabel, Object.assign({ control: React.createElement(Radio, null), checked: isChecked, onClick: onClick, label: label, disabled: disabled, sx: {
            whiteSpace: "nowrap",
            ".MuiRadio-root": {
                color: `${theme.palette.grey[400]} !important`,
            },
            ".Mui-checked": {
                color: `${theme.palette.success.main} !important`,
            },
        } }, props)));
};
const CommunitiesSelector = (_a) => {
    var _b;
    var { options, field } = _a, props = __rest(_a, ["options", "field"]);
    const intl = useIntl();
    const [optionSelected, setOptionSelected] = useState("all");
    const [communitiesSelected, setCommunitiesSelected] = useState(field.value);
    return (React.createElement(PeekStack, { sx: {
            ".MuiFormControl-root": {
                margin: 0,
                label: {
                    display: "none",
                },
            },
        } },
        React.createElement(PeekFormLabel, null, intl.formatMessage(messages.communitiesTitle)),
        React.createElement(PeekRadioGroup, { sx: { flexDirection: "row" } },
            React.createElement(CustomFormLabel, { isChecked: optionSelected === "all", label: "All", onClick: () => {
                    setOptionSelected("all");
                    field.onChange({
                        target: { name: field.name, value: options.map((option) => option._id) },
                    });
                }, "data-testid": `all-communities-selector` }),
            React.createElement(CustomFormLabel, { isChecked: optionSelected === "selected", label: "Selected", onClick: () => {
                    setOptionSelected("selected");
                    field.onChange({
                        target: { name: field.name, value: communitiesSelected },
                    });
                }, "data-testid": `selected-communities-selector`, disabled: !((_b = field.value) === null || _b === void 0 ? void 0 : _b.length) })),
        optionSelected === "selected" && (React.createElement(PeekMultipleSelector, Object.assign({}, props, { options: options, field: field, selectedOptions: communitiesSelected, onSelectionChange: (selection) => {
                setCommunitiesSelected(selection);
                field.onChange({
                    target: { name: field.name, value: selection },
                });
            }, label: "Filter by community" })))));
};
export default CommunitiesSelector;
